import { render, staticRenderFns } from "./PeakSyncData.vue?vue&type=template&id=2f02a3a4&class=justify-center"
import script from "./PeakSyncData.vue?vue&type=script&lang=js"
export * from "./PeakSyncData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports